(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-luxury-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('luxury-product-video')) {
  customElements.define('luxury-product-video', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const video = this.querySelector('video');
      const button = this.querySelector('[data-luxury-video-play]');
      if (!video || !button) return;
      button.hidden = !video.paused;
      button.addEventListener('click', async () => {
        button.hidden = true;
        video.focus();
        try {
          await video.play();
        } catch {
          button.hidden = false;
          button.focus();
        }
      });
      video.addEventListener('play', () => { button.hidden = true; });
      video.addEventListener('pause', () => { button.hidden = false; });
      video.addEventListener('ended', () => { button.hidden = false; });
    }
    disconnectedCallback() {
      const video = this.querySelector('video');
      if (video) video.pause();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
